import type { SaleDict } from './sale-i18n';

// Luồng đặt phòng online của khách (components/sale/SaleBookingPanel.tsx). `**x**` = chữ đậm (render bằng Rich),
// {name} = biến. Đây là luồng thanh toán — giữ nghĩa sát bản vi.
export const SALE_DICT: SaleDict = {
  // ── thông báo lỗi map từ mã lỗi server ──
  'book.err.unavailable': {
    vi: 'Căn này không còn trống trong khoảng ngày đã chọn. Vui lòng chọn ngày khác.',
    en: 'This unit is no longer available for the selected dates. Please choose different dates.',
    zh: '该房源在所选日期已无空房，请选择其他日期。',
    ko: '선택하신 날짜에는 이 객실이 더 이상 예약 가능하지 않습니다. 다른 날짜를 선택해 주세요.',
    fr: "Ce logement n'est plus disponible aux dates choisies. Veuillez choisir d'autres dates.",
    ja: 'この客室は選択された日程では空きがありません。別の日程をお選びください。',
  },
  'book.err.past_date': {
    vi: 'Ngày nhận phòng không được ở quá khứ.',
    en: 'The check-in date cannot be in the past.',
    zh: '入住日期不能是过去的日期。',
    ko: '체크인 날짜는 과거일 수 없습니다.',
    fr: "La date d'arrivée ne peut pas être dans le passé.",
    ja: 'チェックイン日に過去の日付は指定できません。',
  },
  'book.err.invalid_dates': {
    vi: 'Ngày trả phòng phải sau ngày nhận phòng.',
    en: 'The check-out date must be after the check-in date.',
    zh: '退房日期必须晚于入住日期。',
    ko: '체크아웃 날짜는 체크인 날짜보다 이후여야 합니다.',
    fr: "La date de départ doit être postérieure à la date d'arrivée.",
    ja: 'チェックアウト日はチェックイン日より後の日付にしてください。',
  },
  'book.err.booking_disabled': {
    vi: 'Toà này chưa mở đặt phòng online — vui lòng bấm "Gọi lại cho tôi" hoặc liên hệ trực tiếp.',
    en: 'Online booking is not yet available for this building — please tap "Call me back" or contact us directly.',
    zh: '该楼栋暂未开放在线预订——请点击“请回电给我”或直接联系我们。',
    ko: '이 건물은 아직 온라인 예약을 받지 않습니다. "전화 요청"을 누르시거나 직접 문의해 주세요.',
    fr: 'La réservation en ligne n’est pas encore ouverte pour cet immeuble — veuillez cliquer sur « Rappelez-moi » ou nous contacter directement.',
    ja: 'この建物ではまだオンライン予約を受け付けておりません。「折り返し電話を希望」をタップするか、直接お問い合わせください。',
  },
  'book.err.min_stay': {
    vi: 'Căn này yêu cầu ở tối thiểu {n} đêm.',
    en: 'This unit requires a minimum stay of {n} night(s).',
    zh: '该房源最少需入住 {n} 晚。',
    ko: '이 객실은 최소 {n}박 이상 숙박하셔야 합니다.',
    fr: 'Ce logement requiert un séjour minimum de {n} nuit(s).',
    ja: 'この客室は最低{n}泊からご利用いただけます。',
  },
  'book.err.max_stay': {
    vi: 'Căn này cho ở tối đa {n} đêm.',
    en: 'This unit allows a maximum stay of {n} night(s).',
    zh: '该房源最多可入住 {n} 晚。',
    ko: '이 객실은 최대 {n}박까지 숙박하실 수 있습니다.',
    fr: 'Ce logement autorise un séjour maximum de {n} nuit(s).',
    ja: 'この客室は最大{n}泊までご利用いただけます。',
  },
  'book.err.too_many_guests': {
    vi: 'Căn này chỉ nhận tối đa {n} khách người lớn.',
    en: 'This unit accepts a maximum of {n} adult guests.',
    zh: '该房源最多接待 {n} 位成人。',
    ko: '이 객실은 성인 최대 {n}명까지 투숙 가능합니다.',
    fr: 'Ce logement accueille au maximum {n} adultes.',
    ja: 'この客室のご利用人数は大人最大{n}名までです。',
  },
  'book.err.no_price': {
    vi: 'Căn này chưa có giá để đặt online — vui lòng liên hệ trực tiếp.',
    en: 'This unit has no price available for online booking yet — please contact us directly.',
    zh: '该房源暂无可在线预订的价格——请直接联系我们。',
    ko: '이 객실은 아직 온라인 예약 가격이 없습니다. 직접 문의해 주세요.',
    fr: "Ce logement n'a pas encore de tarif pour la réservation en ligne — veuillez nous contacter directement.",
    ja: 'この客室はまだオンライン予約用の料金が設定されていません。直接お問い合わせください。',
  },
  'book.err.rate_limited': {
    vi: 'Bạn thao tác quá nhanh, vui lòng thử lại sau ít phút.',
    en: 'You are doing that too quickly. Please try again in a few minutes.',
    zh: '操作过于频繁，请几分钟后再试。',
    ko: '요청이 너무 빠릅니다. 잠시 후 다시 시도해 주세요.',
    fr: 'Vous allez trop vite. Veuillez réessayer dans quelques minutes.',
    ja: '操作が速すぎます。数分後にもう一度お試しください。',
  },
  'book.err.invalid_guest': {
    vi: 'Vui lòng nhập đúng họ tên và số điện thoại (email nếu điền phải hợp lệ).',
    en: 'Please enter a valid full name and phone number (and a valid email if you fill it in).',
    zh: '请填写正确的姓名和电话号码（如填写邮箱，须为有效邮箱）。',
    ko: '올바른 성함과 전화번호를 입력해 주세요(이메일을 입력하시는 경우 유효한 형식이어야 합니다).',
    fr: "Veuillez saisir un nom complet et un numéro de téléphone valides (ainsi qu'un e-mail valide si vous le renseignez).",
    ja: '正しいお名前と電話番号を入力してください（メールアドレスを入力する場合は有効な形式でご入力ください）。',
  },
  'book.err.far_future': {
    vi: 'Chỉ nhận đặt phòng trong vòng khoảng 18 tháng tới. Vui lòng chọn ngày gần hơn.',
    en: 'We only accept bookings within about the next 18 months. Please choose an earlier date.',
    zh: '仅接受未来约 18 个月内的预订，请选择更近的日期。',
    ko: '향후 약 18개월 이내의 예약만 받습니다. 더 가까운 날짜를 선택해 주세요.',
    fr: 'Nous n’acceptons que les réservations dans les 18 prochains mois environ. Veuillez choisir une date plus proche.',
    ja: 'ご予約は今後約18か月以内の日程のみ承っております。より近い日付をお選びください。',
  },
  'book.err.too_many_pending': {
    vi: 'Bạn đang có đặt phòng chờ thanh toán. Vui lòng thanh toán, hoặc bấm "Gọi lại cho tôi" để nhân viên hỗ trợ, trước khi đặt thêm.',
    en: 'You already have a booking awaiting payment. Please pay for it, or tap "Call me back" so our staff can help, before booking again.',
    zh: '您已有待付款的预订。请先完成付款，或点击“请回电给我”由工作人员协助，然后再继续预订。',
    ko: '결제 대기 중인 예약이 있습니다. 추가 예약 전에 결제를 완료하시거나 "전화 요청"을 눌러 직원의 도움을 받으세요.',
    fr: 'Vous avez déjà une réservation en attente de paiement. Veuillez la régler, ou cliquer sur « Rappelez-moi » pour que notre équipe vous aide, avant de réserver à nouveau.',
    ja: 'お支払い待ちのご予約があります。新たにご予約いただく前に、お支払いを完了いただくか、「折り返し電話を希望」をタップしてスタッフにご相談ください。',
  },
  'book.err.duplicate_pending': {
    vi: 'Bạn đã có đặt phòng chờ thanh toán cho căn và ngày này. Vui lòng hoàn tất thanh toán, hoặc bấm "Gọi lại cho tôi" để nhân viên hỗ trợ.',
    en: 'You already have a booking awaiting payment for this unit and these dates. Please complete the payment, or tap "Call me back" so our staff can help.',
    zh: '您已有该房源和日期的待付款预订。请完成付款，或点击“请回电给我”由工作人员协助。',
    ko: '이 객실과 날짜에 대해 결제 대기 중인 예약이 이미 있습니다. 결제를 완료하시거나 "전화 요청"을 눌러 직원의 도움을 받으세요.',
    fr: 'Vous avez déjà une réservation en attente de paiement pour ce logement et ces dates. Veuillez finaliser le paiement, ou cliquer sur « Rappelez-moi » pour que notre équipe vous aide.',
    ja: 'この客室・日程のお支払い待ちのご予約がすでにあります。お支払いを完了いただくか、「折り返し電話を希望」をタップしてスタッフにご相談ください。',
  },
  'book.err.busy': {
    vi: 'Hệ thống đang có nhiều đặt phòng chờ xử lý. Vui lòng thử lại sau ít phút hoặc bấm "Gọi lại cho tôi".',
    en: 'Many bookings are currently being processed. Please try again in a few minutes or tap "Call me back".',
    zh: '系统当前有较多预订待处理。请几分钟后再试，或点击“请回电给我”。',
    ko: '현재 처리 대기 중인 예약이 많습니다. 잠시 후 다시 시도하시거나 "전화 요청"을 눌러 주세요.',
    fr: 'De nombreuses réservations sont en cours de traitement. Veuillez réessayer dans quelques minutes ou cliquer sur « Rappelez-moi ».',
    ja: '現在、処理待ちのご予約が多くなっております。数分後にもう一度お試しいただくか、「折り返し電話を希望」をタップしてください。',
  },
  'book.err.quote_default': {
    vi: 'Không báo giá được, vui lòng thử lại.',
    en: 'Could not get a price quote. Please try again.',
    zh: '无法获取报价，请重试。',
    ko: '가격을 조회하지 못했습니다. 다시 시도해 주세요.',
    fr: "Impossible d'obtenir un devis. Veuillez réessayer.",
    ja: '料金を取得できませんでした。もう一度お試しください。',
  },
  'book.err.quote_net': {
    vi: 'Không báo giá được — mất mạng hoặc hệ thống lỗi. Vui lòng thử lại.',
    en: 'Could not get a price quote — network or system error. Please try again.',
    zh: '无法获取报价——网络或系统错误，请重试。',
    ko: '가격을 조회하지 못했습니다. 네트워크 또는 시스템 오류입니다. 다시 시도해 주세요.',
    fr: 'Impossible d’obtenir un devis — erreur réseau ou système. Veuillez réessayer.',
    ja: '料金を取得できませんでした（ネットワークまたはシステムエラー）。もう一度お試しください。',
  },
  'book.err.create_default': {
    vi: 'Không đặt được phòng, vui lòng thử lại.',
    en: 'Could not complete the booking. Please try again.',
    zh: '无法完成预订，请重试。',
    ko: '예약을 완료하지 못했습니다. 다시 시도해 주세요.',
    fr: 'Impossible de finaliser la réservation. Veuillez réessayer.',
    ja: 'ご予約を完了できませんでした。もう一度お試しください。',
  },
  'book.err.create_net': {
    vi: 'Không đặt được phòng — mất mạng hoặc hệ thống lỗi. Vui lòng thử lại.',
    en: 'Could not complete the booking — network or system error. Please try again.',
    zh: '无法完成预订——网络或系统错误，请重试。',
    ko: '예약을 완료하지 못했습니다. 네트워크 또는 시스템 오류입니다. 다시 시도해 주세요.',
    fr: 'Impossible de finaliser la réservation — erreur réseau ou système. Veuillez réessayer.',
    ja: 'ご予約を完了できませんでした（ネットワークまたはシステムエラー）。もう一度お試しください。',
  },
  'book.guestcap': {
    vi: 'Căn này chỉ nhận tối đa {n} khách người lớn — đã tự chỉnh về {n}. Nếu đi đông hơn, bấm "Gọi lại cho tôi" để nhân viên tư vấn thêm căn.',
    en: 'This unit accepts a maximum of {n} adult guests — we have adjusted it to {n}. If your group is larger, tap "Call me back" and our staff will help with additional units.',
    zh: '该房源最多接待 {n} 位成人——已自动调整为 {n} 位。如人数更多，请点击“请回电给我”，由工作人员为您推荐更多房源。',
    ko: '이 객실은 성인 최대 {n}명까지 투숙 가능하여 {n}명으로 자동 조정했습니다. 인원이 더 많으시면 "전화 요청"을 눌러 추가 객실에 대해 직원과 상담하세요.',
    fr: 'Ce logement accueille au maximum {n} adultes — nous avons ajusté à {n}. Si votre groupe est plus nombreux, cliquez sur « Rappelez-moi » et notre équipe vous conseillera d’autres logements.',
    ja: 'この客室のご利用人数は大人最大{n}名までのため、{n}名に自動調整しました。それ以上の人数でご利用の場合は、「折り返し電話を希望」をタップしてください。スタッフが追加の客室をご案内します。',
  },

  // ── QR ──
  'book.qr.fail': {
    vi: 'Không tạo được mã QR — dùng thông tin chuyển khoản bên dưới.',
    en: 'Could not generate the QR code — please use the bank transfer details below.',
    zh: '无法生成二维码——请使用下方的转账信息。',
    ko: 'QR 코드를 생성하지 못했습니다. 아래 계좌 이체 정보를 이용해 주세요.',
    fr: 'Impossible de générer le code QR — utilisez les coordonnées de virement ci-dessous.',
    ja: 'QRコードを作成できませんでした。下記の銀行振込情報をご利用ください。',
  },
  'book.qr.alt': {
    vi: 'Mã QR thanh toán', en: 'Payment QR code', zh: '付款二维码', ko: '결제 QR 코드', fr: 'Code QR de paiement',
    ja: '支払い用QRコード',
  },

  // ── thời gian giữ chỗ ──
  'book.hold.min': { vi: '{n} phút', en: '{n} min', zh: '{n} 分钟', ko: '{n}분', fr: '{n} min', ja: '{n}分' },
  'book.hold.hour': { vi: '{n} giờ', en: '{n} h', zh: '{n} 小时', ko: '{n}시간', fr: '{n} h', ja: '{n}時間' },
  'book.hold.hourmin': { vi: '{h} giờ {m} phút', en: '{h} h {m} min', zh: '{h} 小时 {m} 分钟', ko: '{h}시간 {m}분', fr: '{h} h {m} min', ja: '{h}時間{m}分' },
  'book.hold.title_until': {
    vi: '⏳ Phòng được giữ cho bạn {hold} — đến {until}',
    en: '⏳ Your room is held for {hold} — until {until}',
    zh: '⏳ 房间为您保留 {hold}——至 {until}',
    ko: '⏳ 객실을 {hold} 동안 보관해 드립니다 — {until}까지',
    fr: '⏳ Votre logement est réservé pour {hold} — jusqu’à {until}',
    ja: '⏳ お部屋を{hold}仮押さえしています（{until}まで）',
  },
  'book.hold.title_now': {
    vi: '⏳ Phòng được giữ cho bạn {hold} kể từ lúc bấm đặt',
    en: '⏳ Your room is held for {hold} from the moment you book',
    zh: '⏳ 自您点击预订起，房间为您保留 {hold}',
    ko: '⏳ 예약 버튼을 누른 시점부터 {hold} 동안 객실을 보관해 드립니다',
    fr: '⏳ Votre logement est réservé pendant {hold} à partir du moment où vous réservez',
    ja: '⏳ ご予約ボタンを押した時点から{hold}、お部屋を仮押さえします',
  },
  'book.hold.li_pay': {
    vi: 'Thanh toán **trong {hold}** để đặt phòng được xác nhận.',
    en: 'Pay **within {hold}** for your booking to be confirmed.',
    zh: '请**在 {hold} 内**付款，预订方可确认。',
    ko: '예약이 확정되려면 **{hold} 이내**에 결제해 주세요.',
    fr: 'Payez **dans les {hold}** pour que votre réservation soit confirmée.',
    ja: 'ご予約を確定するには、**{hold}以内**にお支払いください。',
  },
  'book.hold.li_expire': {
    vi: 'Quá {hold} chưa thanh toán, **phòng sẽ được mở lại cho khách khác** đặt.',
    en: 'If unpaid after {hold}, **the room will be released for other guests** to book.',
    zh: '超过 {hold} 未付款，**房间将重新开放给其他客人预订**。',
    ko: '{hold}이 지나도 결제하지 않으시면 **객실은 다른 고객이 예약할 수 있도록 다시 열립니다**.',
    fr: 'Passé {hold} sans paiement, **le logement sera remis en vente** pour d’autres voyageurs.',
    ja: '{hold}を過ぎてもお支払いがない場合、**お部屋は他のお客様がご予約できるよう再び開放されます**。',
  },
  'book.hold.li_transfer': {
    vi: 'Chuyển khoản xong, nhân viên sẽ kiểm tra và xác nhận (không tức thì) rồi liên hệ qua số điện thoại bạn đã nhập.',
    en: 'After you transfer the money, our staff will check and confirm it (not instantly), then contact you at the phone number you entered.',
    zh: '转账完成后，工作人员会核对并确认（非即时），随后通过您填写的电话号码与您联系。',
    ko: '이체 후 직원이 확인하고 승인하며(즉시 처리되지 않습니다), 입력하신 전화번호로 연락드립니다.',
    fr: 'Après votre virement, notre équipe vérifiera et confirmera (pas instantanément), puis vous contactera au numéro de téléphone saisi.',
    ja: 'お振込み後、スタッフが入金を確認して予約を確定し（即時ではありません）、ご入力いただいた電話番号にご連絡します。',
  },
  'book.hold.li_auto': {
    vi: 'Thanh toán xong, đặt phòng được xác nhận tự động trong vài giây.',
    en: 'Once paid, your booking is confirmed automatically within a few seconds.',
    zh: '付款完成后，预订将在几秒内自动确认。',
    ko: '결제가 완료되면 몇 초 내에 예약이 자동으로 확정됩니다.',
    fr: 'Une fois le paiement effectué, votre réservation est confirmée automatiquement en quelques secondes.',
    ja: 'お支払いが完了すると、数秒以内にご予約が自動的に確定します。',
  },
  'book.hold.li_late': {
    vi: 'Nếu bạn **đã chuyển khoản mà quá hạn**, hãy liên hệ ngay để chúng tôi xử lý (giữ phòng hoặc hoàn tiền).',
    en: 'If you **have already paid but the hold expired**, please contact us right away so we can sort it out (keep the room or refund you).',
    zh: '如果您**已转账但已超过保留时间**，请立即联系我们处理（保留房间或退款）。',
    ko: '**이미 이체하셨는데 보관 시간이 지난 경우** 즉시 연락해 주세요. 객실 보관 또는 환불로 처리해 드립니다.',
    fr: 'Si vous **avez déjà payé mais que le délai est dépassé**, contactez-nous immédiatement afin que nous régularisions (conserver le logement ou vous rembourser).',
    ja: '**お振込み済みで仮押さえの期限を過ぎてしまった場合**は、至急ご連絡ください（お部屋の確保または返金で対応いたします）。',
  },
  'book.hold.contact': { vi: 'Liên hệ:', en: 'Contact:', zh: '联系方式：', ko: '연락처:', fr: 'Contact :', ja: 'お問い合わせ：' },

  // ── "Gọi lại cho tôi" ──
  'book.cb.copyfail': {
    vi: 'Không copy được — bạn có thể bấm vào số để gọi.',
    en: 'Could not copy — you can tap the number to call.',
    zh: '无法复制——您可以直接点击号码拨打。',
    ko: '복사하지 못했습니다. 번호를 눌러 전화하실 수 있습니다.',
    fr: 'Copie impossible — vous pouvez appuyer sur le numéro pour appeler.',
    ja: 'コピーできませんでした。番号をタップして電話をおかけいただけます。',
  },
  'book.cb.err_phone': {
    vi: 'Vui lòng nhập số điện thoại hợp lệ.', en: 'Please enter a valid phone number.',
    zh: '请输入有效的电话号码。', ko: '올바른 전화번호를 입력해 주세요.', fr: 'Veuillez saisir un numéro de téléphone valide.',
    ja: '有効な電話番号を入力してください。',
  },
  'book.cb.err_rate': {
    vi: 'Bạn đã gửi nhiều yêu cầu, vui lòng thử lại sau ít phút.',
    en: 'You have sent many requests. Please try again in a few minutes.',
    zh: '您已发送多次请求，请几分钟后再试。',
    ko: '요청을 너무 많이 보내셨습니다. 잠시 후 다시 시도해 주세요.',
    fr: 'Vous avez envoyé de nombreuses demandes. Veuillez réessayer dans quelques minutes.',
    ja: 'リクエストが多すぎます。数分後にもう一度お試しください。',
  },
  'book.cb.err_fail': {
    vi: 'Không gửi được yêu cầu, vui lòng thử lại.', en: 'Could not send your request. Please try again.',
    zh: '无法发送请求，请重试。', ko: '요청을 보내지 못했습니다. 다시 시도해 주세요.', fr: "Impossible d'envoyer votre demande. Veuillez réessayer.",
    ja: 'リクエストを送信できませんでした。もう一度お試しください。',
  },
  'book.cb.err_net': {
    vi: 'Không gửi được yêu cầu — mất mạng hoặc hệ thống lỗi. Vui lòng thử lại.',
    en: 'Could not send your request — network or system error. Please try again.',
    zh: '无法发送请求——网络或系统错误，请重试。',
    ko: '요청을 보내지 못했습니다. 네트워크 또는 시스템 오류입니다. 다시 시도해 주세요.',
    fr: 'Impossible d’envoyer votre demande — erreur réseau ou système. Veuillez réessayer.',
    ja: 'リクエストを送信できませんでした（ネットワークまたはシステムエラー）。もう一度お試しください。',
  },
  'book.cb.sent': {
    vi: '✅ Đã gửi yêu cầu. Nhân viên sẽ gọi lại số **{phone}** để trao đổi với bạn về đặt phòng.',
    en: '✅ Request sent. Our staff will call you back at **{phone}** to discuss your booking.',
    zh: '✅ 请求已发送。工作人员将回电至 **{phone}**，与您沟通预订事宜。',
    ko: '✅ 요청이 전송되었습니다. 직원이 **{phone}** 번호로 전화드려 예약에 대해 상담해 드립니다.',
    fr: '✅ Demande envoyée. Notre équipe vous rappellera au **{phone}** pour échanger sur votre réservation.',
    ja: '✅ リクエストを送信しました。スタッフが**{phone}**に折り返しお電話し、ご予約についてご相談します。',
  },
  'book.cb.unsent': {
    vi: 'Yêu cầu của bạn đã được lưu nhưng chưa thông báo được cho nhân viên ngay.',
    en: 'Your request has been saved, but we could not notify our staff immediately.',
    zh: '您的请求已保存，但暂时无法立即通知工作人员。',
    ko: '요청은 저장되었으나 직원에게 즉시 알리지 못했습니다.',
    fr: 'Votre demande a été enregistrée mais nous n’avons pas pu en informer notre équipe immédiatement.',
    ja: 'リクエストは保存されましたが、スタッフにすぐに通知できませんでした。',
  },
  'book.cb.call_direct': {
    vi: 'Vui lòng gọi trực tiếp', en: 'Please call us directly at', zh: '请直接致电', ko: '직접 전화해 주세요:', fr: 'Veuillez nous appeler directement au',
    ja: 'お手数ですが、直接お電話ください：',
  },
  'book.cb.retry_later': {
    vi: 'Vui lòng thử lại sau ít phút.', en: 'Please try again in a few minutes.',
    zh: '请几分钟后再试。', ko: '잠시 후 다시 시도해 주세요.', fr: 'Veuillez réessayer dans quelques minutes.',
    ja: '数分後にもう一度お試しください。',
  },
  'book.cb.btn': { vi: '📞 Gọi lại cho tôi', en: '📞 Call me back', zh: '📞 请回电给我', ko: '📞 전화 요청', fr: '📞 Rappelez-moi', ja: '📞 折り返し電話を希望' },
  'book.cb.or_call': { vi: 'hoặc tự gọi:', en: 'or call us:', zh: '或自行拨打：', ko: '또는 직접 전화:', fr: 'ou appelez-nous :', ja: 'またはお電話ください：' },
  'book.copied_short': { vi: 'Đã copy ✓', en: 'Copied ✓', zh: '已复制 ✓', ko: '복사됨 ✓', fr: 'Copié ✓', ja: 'コピーしました ✓' },
  'book.copy_btn': { vi: 'Copy', en: 'Copy', zh: '复制', ko: '복사', fr: 'Copier', ja: 'コピー' },
  'book.cb.hint': {
    vi: 'Để lại số điện thoại, nhân viên sẽ gọi lại trao đổi với bạn về đặt phòng.',
    en: 'Leave your phone number and our staff will call you back to discuss your booking.',
    zh: '请留下您的电话号码，工作人员将回电与您沟通预订事宜。',
    ko: '전화번호를 남겨 주시면 직원이 전화드려 예약에 대해 상담해 드립니다.',
    fr: 'Laissez votre numéro de téléphone et notre équipe vous rappellera pour échanger sur votre réservation.',
    ja: '電話番号をご入力いただくと、スタッフが折り返しお電話し、ご予約についてご相談します。',
  },
  'book.cb.prefilled': {
    vi: ' Số điện thoại điền sẵn từ thông tin bạn đã nhập — sửa nếu chưa đúng.',
    en: ' The phone number was pre-filled from what you entered earlier — edit it if it is wrong.',
    zh: ' 电话号码已根据您之前填写的信息自动填入——如有错误请修改。',
    ko: ' 전화번호는 이전에 입력하신 정보로 미리 채워져 있습니다. 틀린 경우 수정해 주세요.',
    fr: ' Le numéro a été pré-rempli à partir de vos saisies précédentes — corrigez-le s’il est inexact.',
    ja: ' 電話番号は先ほど入力された情報から自動入力されています。誤りがある場合は修正してください。',
  },
  'book.cb.ph_phone': {
    vi: 'Số điện thoại / Zalo *', en: 'Phone / WhatsApp / Zalo *', zh: '电话 / WhatsApp / Zalo *', ko: '전화번호 / WhatsApp / Zalo *', fr: 'Téléphone / WhatsApp / Zalo *',
    ja: '電話番号 / WhatsApp / Zalo *',
  },
  'book.cb.ph_name': {
    vi: 'Tên của bạn (không bắt buộc)', en: 'Your name (optional)', zh: '您的姓名（选填）', ko: '성함 (선택)', fr: 'Votre nom (facultatif)',
    ja: 'お名前（任意）',
  },
  'book.sending': { vi: 'Đang gửi…', en: 'Sending…', zh: '发送中…', ko: '전송 중…', fr: 'Envoi…', ja: '送信中…' },
  'book.cb.send': {
    vi: 'Gửi yêu cầu gọi lại', en: 'Request a call back', zh: '提交回电请求', ko: '전화 요청 보내기', fr: 'Demander à être rappelé',
    ja: '折り返し電話をリクエスト',
  },

  // ── nút mở + các màn kết quả ──
  'book.open.title': { vi: '🛎️ Đặt phòng ngay', en: '🛎️ Book now', zh: '🛎️ 立即预订', ko: '🛎️ 지금 예약', fr: '🛎️ Réserver maintenant', ja: '🛎️ 今すぐ予約' },
  'book.open.sub_disc': {
    vi: 'Giảm {pct}% khi đặt & thanh toán online · ',
    en: '{pct}% off when you book & pay online · ',
    zh: '在线预订并付款立减 {pct}% · ',
    ko: '온라인 예약 및 결제 시 {pct}% 할인 · ',
    fr: '{pct} % de réduction en réservant et payant en ligne · ',
    ja: 'オンライン予約・決済で{pct}%オフ · ',
  },
  'book.open.sub': {
    vi: 'Chuyển khoản qua QR, xác nhận ngay', en: 'Pay by QR bank transfer, instant confirmation',
    zh: '扫码转账付款，即时确认', ko: 'QR 계좌 이체, 즉시 확정', fr: 'Paiement par virement via QR, confirmation immédiate',
    ja: 'QRコードで銀行振込、即時確定',
  },
  'book.code': { vi: 'Mã booking:', en: 'Booking code:', zh: '预订编号：', ko: '예약 번호:', fr: 'Code de réservation :', ja: '予約番号：' },
  'book.paid.title': {
    vi: '✅ Đã nhận thanh toán — đặt phòng thành công', en: '✅ Payment received — booking confirmed',
    zh: '✅ 已收到付款——预订成功', ko: '✅ 결제가 확인되었습니다 — 예약 완료', fr: '✅ Paiement reçu — réservation confirmée',
    ja: '✅ お支払いを確認しました — ご予約が完了しました',
  },
  'book.paid.body': {
    vi: '{from} → {to}. Đội vận hành sẽ liên hệ hướng dẫn nhận phòng.',
    en: '{from} → {to}. Our operations team will contact you with check-in instructions.',
    zh: '{from} → {to}。运营团队将与您联系，指导入住事宜。',
    ko: '{from} → {to}. 운영팀이 체크인 안내를 위해 연락드립니다.',
    fr: '{from} → {to}. Notre équipe vous contactera avec les instructions d’arrivée.',
    ja: '{from} → {to}。運営チームよりチェックインのご案内をご連絡します。',
  },
  'book.conflict.title': {
    vi: 'Rất tiếc — phòng vừa được khách khác đặt trước',
    en: 'Sorry — the room was just booked by another guest',
    zh: '非常抱歉——房间刚刚被其他客人预订',
    ko: '죄송합니다. 방금 다른 고객이 먼저 객실을 예약했습니다',
    fr: 'Désolé — le logement vient d’être réservé par un autre voyageur',
    ja: '申し訳ありません — 先ほど他のお客様がこのお部屋をご予約されました',
  },
  'book.conflict.body': {
    vi: 'Chúng tôi đã nhận khoản chuyển khoản của bạn và sẽ liên hệ ngay để đổi phòng hoặc hoàn tiền. Mã tham chiếu: **{id}**',
    en: 'We have received your transfer and will contact you right away to switch rooms or refund you. Reference code: **{id}**',
    zh: '我们已收到您的转账，将立即联系您为您换房或退款。参考编号：**{id}**',
    ko: '이체 내역을 확인했으며, 객실 변경 또는 환불을 위해 즉시 연락드리겠습니다. 참조 번호: **{id}**',
    fr: 'Nous avons bien reçu votre virement et vous contacterons immédiatement pour changer de logement ou vous rembourser. Référence : **{id}**',
    ja: 'お振込みを確認しております。お部屋の変更または返金のため、すぐにご連絡いたします。参照番号：**{id}**',
  },
  'book.held.title': { vi: 'Đã giữ chỗ cho bạn', en: 'Your room is on hold', zh: '已为您保留房间', ko: '객실을 보관해 두었습니다', fr: 'Votre logement est réservé', ja: 'お部屋を仮押さえしました' },
  'book.held.body': {
    vi: 'Mã booking: **{id}**. Đội vận hành sẽ liên hệ qua số điện thoại bạn đã nhập để hướng dẫn thanh toán — phòng được giữ {hold}, quá hạn chưa thanh toán phòng sẽ được mở lại.',
    en: 'Booking code: **{id}**. Our operations team will contact you at the phone number you entered with payment instructions — the room is held for {hold}; if unpaid after that, it will be released.',
    zh: '预订编号：**{id}**。运营团队将通过您填写的电话号码联系您，指导付款——房间保留 {hold}，逾期未付款将重新开放。',
    ko: '예약 번호: **{id}**. 운영팀이 입력하신 전화번호로 결제 방법을 안내해 드립니다. 객실은 {hold} 동안 보관되며, 기한 내 결제하지 않으시면 다시 열립니다.',
    fr: 'Code de réservation : **{id}**. Notre équipe vous contactera au numéro saisi avec les instructions de paiement — le logement est réservé pendant {hold} ; sans paiement passé ce délai, il sera remis en vente.',
    ja: '予約番号：**{id}**。運営チームがご入力いただいた電話番号にお支払い方法をご連絡します。お部屋は{hold}仮押さえされ、期限内にお支払いがない場合は再び開放されます。',
  },
  'book.expired.title': {
    vi: '⌛ Đã hết thời gian giữ chỗ ({hold})', en: '⌛ The hold time has expired ({hold})',
    zh: '⌛ 保留时间已结束（{hold}）', ko: '⌛ 객실 보관 시간이 만료되었습니다 ({hold})', fr: '⌛ Le délai de réservation est dépassé ({hold})',
    ja: '⌛ 仮押さえの有効期限が切れました（{hold}）',
  },
  'book.expired.body': {
    vi: 'Phòng đã được mở lại cho khách khác. Nếu bạn **đã chuyển khoản**, vui lòng liên hệ ngay{phone} để chúng tôi xử lý (mã booking **{id}**). Nếu chưa, bạn có thể đặt lại.',
    en: 'The room has been released for other guests. If you **have already transferred the money**, please contact us right away{phone} so we can sort it out (booking code **{id}**). If not, you can book again.',
    zh: '房间已重新开放给其他客人。如果您**已经转账**，请立即联系{phone}，以便我们处理（预订编号 **{id}**）。如未转账，您可以重新预订。',
    ko: '객실이 다른 고객에게 다시 열렸습니다. **이미 이체하셨다면** 즉시 연락해 주세요{phone}. 처리해 드리겠습니다(예약 번호 **{id}**). 아직 이체 전이시면 다시 예약하실 수 있습니다.',
    fr: 'Le logement a été remis en vente. Si vous **avez déjà effectué le virement**, contactez-nous immédiatement{phone} afin que nous régularisions (code de réservation **{id}**). Sinon, vous pouvez réserver à nouveau.',
    ja: 'お部屋は他のお客様向けに再び開放されました。**すでにお振込み済み**の場合は、至急ご連絡ください{phone}。対応いたします（予約番号 **{id}**）。まだお振込みされていない場合は、改めてご予約いただけます。',
  },
  'book.rebook': { vi: 'Đặt lại', en: 'Book again', zh: '重新预订', ko: '다시 예약', fr: 'Réserver à nouveau', ja: '再予約する' },

  // ── màn QR ──
  'book.pay.title': { vi: 'Quét QR để thanh toán', en: 'Scan the QR code to pay', zh: '扫描二维码付款', ko: 'QR 코드를 스캔하여 결제', fr: 'Scannez le code QR pour payer', ja: 'QRコードをスキャンしてお支払い' },
  'book.pay.left': { vi: '⏳ còn {time}', en: '⏳ {time} left', zh: '⏳ 剩余 {time}', ko: '⏳ {time} 남음', fr: '⏳ {time} restantes', ja: '⏳ 残り{time}' },
  'book.pay.deposit': {
    vi: 'đặt cọc · tổng tiền {total}, phần còn lại thanh toán khi nhận phòng',
    en: 'deposit · total {total}, the remainder is paid at check-in',
    zh: '定金 · 总额 {total}，余款入住时支付',
    ko: '예약금 · 총액 {total}, 잔액은 체크인 시 결제',
    fr: 'acompte · total {total}, le solde est à régler à l’arrivée',
    ja: '内金 · 合計{total}、残額はチェックイン時にお支払い',
  },
  'book.pay.bank': { vi: 'Ngân hàng:', en: 'Bank:', zh: '银行：', ko: '은행:', fr: 'Banque :', ja: '銀行：' },
  'book.pay.acc_no': { vi: 'Số TK:', en: 'Account no.:', zh: '账号：', ko: '계좌번호:', fr: 'N° de compte :', ja: '口座番号：' },
  'book.pay.acc_name': { vi: 'Chủ TK:', en: 'Account holder:', zh: '户名：', ko: '예금주:', fr: 'Titulaire :', ja: '口座名義：' },
  'book.pay.copy': { vi: 'copy', en: 'copy', zh: '复制', ko: '복사', fr: 'copier', ja: 'コピー' },
  'book.pay.content': {
    vi: 'Nội dung chuyển khoản (giữ NGUYÊN):', en: 'Transfer description (keep it EXACTLY as is):',
    zh: '转账备注（请原样填写，不要修改）：', ko: '이체 메모 (그대로 입력해 주세요):', fr: 'Libellé du virement (à conserver TEL QUEL) :',
    ja: '振込内容（このまま変更せず入力してください）：',
  },
  'book.copy_account': { vi: 'số tài khoản', en: 'account number', zh: '账号', ko: '계좌번호', fr: 'le numéro de compte', ja: '口座番号' },
  'book.copy_content': { vi: 'nội dung chuyển khoản', en: 'transfer description', zh: '转账备注', ko: '이체 메모', fr: 'le libellé du virement', ja: '振込内容' },
  'book.copied': { vi: 'Đã copy {label}', en: 'Copied: {label}', zh: '已复制：{label}', ko: '복사됨: {label}', fr: 'Copié : {label}', ja: 'コピーしました：{label}' },
  'book.copyfail': { vi: 'Không copy được', en: 'Could not copy', zh: '无法复制', ko: '복사하지 못했습니다', fr: 'Copie impossible', ja: 'コピーできませんでした' },
  'book.claim.sent': {
    vi: '✅ Đã báo nhân viên kiểm tra sao kê. Khi nhận được tiền, nhân viên sẽ xác nhận booking và liên hệ bạn.',
    en: '✅ Our staff has been notified to check the bank statement. Once the money is received, they will confirm your booking and contact you.',
    zh: '✅ 已通知工作人员核对银行流水。收到款项后，工作人员将确认您的预订并与您联系。',
    ko: '✅ 직원에게 입금 내역 확인을 요청했습니다. 입금이 확인되면 예약을 확정하고 연락드립니다.',
    fr: '✅ Notre équipe a été prévenue de vérifier le relevé bancaire. Dès réception des fonds, elle confirmera votre réservation et vous contactera.',
    ja: '✅ スタッフに入金確認を依頼しました。入金を確認でき次第、ご予約を確定し、ご連絡します。',
  },
  'book.claim.unsent': {
    vi: 'Đã ghi nhận, nhưng chưa thông báo được cho nhân viên ngay — vui lòng bấm "Gọi lại cho tôi" bên dưới hoặc gọi trực tiếp.',
    en: 'Noted, but we could not notify our staff immediately — please tap "Call me back" below or call us directly.',
    zh: '已记录，但暂时无法立即通知工作人员——请点击下方“请回电给我”或直接致电。',
    ko: '접수되었으나 직원에게 즉시 알리지 못했습니다. 아래 "전화 요청"을 누르시거나 직접 전화해 주세요.',
    fr: 'Enregistré, mais nous n’avons pas pu prévenir notre équipe immédiatement — veuillez cliquer sur « Rappelez-moi » ci-dessous ou nous appeler directement.',
    ja: '受け付けましたが、スタッフにすぐに通知できませんでした。下の「折り返し電話を希望」をタップするか、直接お電話ください。',
  },
  'book.claim.btn': { vi: '✅ Tôi đã chuyển khoản', en: '✅ I have transferred the money', zh: '✅ 我已转账', ko: '✅ 이체를 완료했습니다', fr: '✅ J’ai effectué le virement', ja: '✅ 振込みを完了しました' },
  'book.claim.err': {
    vi: 'Chưa gửi được thông báo — vui lòng thử lại hoặc bấm "Gọi lại cho tôi"',
    en: 'Could not send the notification — please try again or tap "Call me back"',
    zh: '通知发送失败——请重试或点击“请回电给我”',
    ko: '알림을 보내지 못했습니다. 다시 시도하시거나 "전화 요청"을 눌러 주세요',
    fr: 'Impossible d’envoyer la notification — veuillez réessayer ou cliquer sur « Rappelez-moi »',
    ja: '通知を送信できませんでした。もう一度お試しいただくか、「折り返し電話を希望」をタップしてください',
  },
  'book.pay.open_page': { vi: 'Mở trang thanh toán', en: 'Open the payment page', zh: '打开付款页面', ko: '결제 페이지 열기', fr: 'Ouvrir la page de paiement', ja: '支払いページを開く' },

  // ── form đặt phòng + báo giá ──
  'book.title': { vi: '🛎️ Đặt phòng', en: '🛎️ Book', zh: '🛎️ 预订', ko: '🛎️ 예약', fr: '🛎️ Réserver', ja: '🛎️ 予約' },
  'book.adults': { vi: 'Người lớn', en: 'Adults', zh: '成人', ko: '성인', fr: 'Adultes', ja: '大人' },
  'book.children': { vi: 'Trẻ em', en: 'Children', zh: '儿童', ko: '아동', fr: 'Enfants', ja: 'お子様' },
  'book.extra_note': {
    vi: 'Căn này tiêu chuẩn {max} khách người lớn — khách thứ {next} trở đi tính phụ thu {fee}/người/đêm (không áp giảm giá), đã cộng vào tổng bên dưới.',
    en: 'This unit is standard for {max} adult guests — from guest {next} onward an extra fee of {fee}/person/night applies (no discount), already included in the total below.',
    zh: '该房源标准入住 {max} 位成人——从第 {next} 位客人起，每人每晚加收 {fee}（不享受折扣），已计入下方总价。',
    ko: '이 객실의 기본 인원은 성인 {max}명이며, {next}번째 손님부터 1인 1박당 {fee}의 추가 요금이 부과됩니다(할인 미적용). 아래 총액에 이미 포함되어 있습니다.',
    fr: 'Ce logement est prévu pour {max} adultes — à partir du {next}e voyageur, un supplément de {fee}/personne/nuit s’applique (sans remise), déjà inclus dans le total ci-dessous.',
    ja: 'この客室の基本人数は大人{max}名です。{next}名様以降は1名1泊あたり{fee}の追加料金がかかります（割引対象外）。下記の合計金額に含まれています。',
  },
  'book.extra_hint': {
    vi: 'Căn tiêu chuẩn {max} khách, nhận thêm tối đa {more} người với phụ thu {fee}/người/đêm.',
    en: 'This unit is standard for {max} guests and accepts up to {more} more with an extra fee of {fee}/person/night.',
    zh: '该房源标准入住 {max} 位客人，最多可再加 {more} 人，每人每晚加收 {fee}。',
    ko: '이 객실의 기본 인원은 {max}명이며, 최대 {more}명까지 추가 가능합니다(1인 1박당 {fee} 추가 요금).',
    fr: 'Ce logement est prévu pour {max} voyageurs et peut en accueillir jusqu’à {more} de plus moyennant {fee}/personne/nuit.',
    ja: 'この客室の基本人数は{max}名で、最大{more}名まで追加可能です（1名1泊あたり{fee}の追加料金）。',
  },
  'book.checking': { vi: 'Đang kiểm tra phòng trống…', en: 'Checking availability…', zh: '正在查询空房…', ko: '예약 가능 여부 확인 중…', fr: 'Vérification des disponibilités…', ja: '空室状況を確認中…' },
  'book.list_price': {
    vi: 'Giá niêm yết ({n} đêm)', en: 'List price ({n} nights)', zh: '标价（{n} 晚）', ko: '정가 ({n}박)', fr: 'Prix public ({n} nuits)',
    ja: '定価（{n}泊）',
  },
  'book.nights': { vi: '{n} đêm', en: '{n} night(s)', zh: '{n} 晚', ko: '{n}박', fr: '{n} nuit(s)', ja: '{n}泊' },
  'book.discount': {
    vi: 'Giảm {pct}% khi đặt trực tiếp và thanh toán online',
    en: '{pct}% off for booking direct and paying online',
    zh: '直接预订并在线付款立减 {pct}%',
    ko: '직접 예약 및 온라인 결제 시 {pct}% 할인',
    fr: '{pct} % de réduction pour une réservation directe avec paiement en ligne',
    ja: '直接予約・オンライン決済で{pct}%オフ',
  },
  'book.extra_fee': {
    vi: 'Phụ thu thêm {n} khách ({fee} × {n} người × {nights} đêm)',
    en: 'Extra fee for {n} additional guest(s) ({fee} × {n} guest(s) × {nights} night(s))',
    zh: '{n} 位额外客人的附加费（{fee} × {n} 人 × {nights} 晚）',
    ko: '추가 인원 {n}명 요금 ({fee} × {n}명 × {nights}박)',
    fr: 'Supplément pour {n} voyageur(s) en plus ({fee} × {n} personne(s) × {nights} nuit(s))',
    ja: '追加{n}名様の料金（{fee} × {n}名 × {nights}泊）',
  },
  'book.direct_price': { vi: 'Giá đặt trực tiếp', en: 'Direct booking price', zh: '直订价', ko: '직접 예약 가격', fr: 'Prix en réservation directe', ja: '直接予約価格' },
  'book.total': { vi: 'Tổng cộng', en: 'Total', zh: '合计', ko: '합계', fr: 'Total', ja: '合計' },
  'book.deposit_now': { vi: 'Đặt cọc ngay ({pct}%)', en: 'Deposit due now ({pct}%)', zh: '立即支付定金（{pct}%）', ko: '지금 결제할 예약금 ({pct}%)', fr: 'Acompte à régler maintenant ({pct} %)', ja: '今すぐお支払いの内金（{pct}%）' },
  'book.prefilled': {
    vi: 'Đã điền sẵn từ thông tin bạn nhập trước đó — kiểm tra và sửa nếu chưa đúng.',
    en: 'Pre-filled from what you entered earlier — please check and correct if needed.',
    zh: '已根据您之前填写的信息自动填入——请检查，如有错误请修改。',
    ko: '이전에 입력하신 정보로 미리 채워져 있습니다. 확인 후 틀린 부분은 수정해 주세요.',
    fr: 'Pré-rempli à partir de vos saisies précédentes — vérifiez et corrigez si nécessaire.',
    ja: '先ほど入力された情報から自動入力されています。ご確認の上、誤りがあれば修正してください。',
  },
  'book.forget_btn': { vi: 'Xoá thông tin đã lưu', en: 'Clear saved details', zh: '清除已保存的信息', ko: '저장된 정보 삭제', fr: 'Effacer les informations enregistrées', ja: '保存した情報を削除' },
  'book.forgot': {
    vi: 'Đã xoá thông tin đã lưu trên thiết bị này', en: 'Saved details cleared from this device',
    zh: '已清除此设备上保存的信息', ko: '이 기기에 저장된 정보를 삭제했습니다', fr: 'Informations enregistrées effacées de cet appareil',
    ja: 'この端末に保存した情報を削除しました',
  },
  'book.ph_name': { vi: 'Họ tên *', en: 'Full name *', zh: '姓名 *', ko: '성함 *', fr: 'Nom complet *', ja: 'お名前 *' },
  'book.ph_email': { vi: 'Email (không bắt buộc)', en: 'Email (optional)', zh: '邮箱（选填）', ko: '이메일 (선택)', fr: 'E-mail (facultatif)', ja: 'メールアドレス（任意）' },
  'book.ph_nat': { vi: 'Quốc tịch (không bắt buộc)', en: 'Nationality (optional)', zh: '国籍（选填）', ko: '국적 (선택)', fr: 'Nationalité (facultatif)', ja: '国籍（任意）' },
  'book.ph_note': {
    vi: 'Ghi chú (giờ đến, yêu cầu đặc biệt…)', en: 'Notes (arrival time, special requests…)',
    zh: '备注（抵达时间、特殊要求等）', ko: '메모 (도착 시간, 특별 요청 등)', fr: 'Remarques (heure d’arrivée, demandes particulières…)',
    ja: 'ご要望（到着時間、特別なご希望など）',
  },
  'book.creating': { vi: 'Đang tạo đặt phòng…', en: 'Creating your booking…', zh: '正在创建预订…', ko: '예약 생성 중…', fr: 'Création de votre réservation…', ja: 'ご予約を作成中…' },
  'book.submit': {
    vi: 'Đặt phòng & thanh toán {amount}', en: 'Book & pay {amount}', zh: '预订并支付 {amount}', ko: '예약 및 {amount} 결제', fr: 'Réserver et payer {amount}',
    ja: '予約して{amount}を支払う',
  },
};
